var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramHelp64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Help64*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Help",
    transform: "translate(7.000000, 7.000000)",
    stroke: "#4F4D4C",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6808511,14.1762918 C30.4819939,14.1762918 35.1854103,18.8797082 35.1854103,24.6808511 L49.1914894,24.6808511 C49.1914894,11.1439757 38.2177264,0.170212766 24.6808511,0.170212766 L24.6808511,14.1762918 L24.6808511,14.1762918 Z",
    id: "Stroke-3",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1762918,24.6808511 C14.1762918,18.8797082 18.8797082,14.1762918 24.6808511,14.1762918 L24.6808511,0.170212766 C11.1439757,0.170212766 0.170212766,11.1439757 0.170212766,24.6808511 L14.1762918,24.6808511 L14.1762918,24.6808511 Z",
    id: "Stroke-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6808511,35.1854103 C18.8797082,35.1854103 14.1762918,30.4819939 14.1762918,24.6808511 L0.170212766,24.6808511 C0.170212766,38.2177264 11.1439757,49.1914894 24.6808511,49.1914894 L24.6808511,35.1854103 L24.6808511,35.1854103 Z",
    id: "Stroke-11",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1854103,24.6808511 C35.1854103,30.4819939 30.4819939,35.1854103 24.6808511,35.1854103 L24.6808511,49.1914894 C38.2177264,49.1914894 49.1914894,38.2177264 49.1914894,24.6808511 L35.1854103,24.6808511 L35.1854103,24.6808511 Z",
    id: "Stroke-15",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramHelp64);
export default __webpack_public_path__ + "static/media/pictogramHelp64.260cca08954d512459d593af78d20476.svg";
export { ForwardRef as ReactComponent };